import createReactClass from "create-react-class";
import moment from "moment";
import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { AutoSizer, Column, SortDirection, Table } from "react-virtualized";
import _ from "underscore";
import { ServerActions } from "../actions/serverActions";
import { subdivisionStore } from "../stores/subdivision";
import { tabsStore } from "../stores/tabs";
import { territoryStore } from "../stores/territory";
import { formValidation } from "../util/formValidation";
import { getQryValue } from "../util/helper";
import { ContentBox } from "./admin/ContentBox";

import "../css/adminScreen.css";

function getStateFromStores() {
  var historyData = tabsStore.getHistory();
  var gritGroupByCount = _.countBy(historyData, "syncId");
  historyData = _.filter(historyData, function (o) {
    var isRequest = o.status === "request";
    var isOnlyOneRequest = gritGroupByCount[o.syncId] === 1;
    if (isRequest && isOnlyOneRequest) {
      return true;
    }
    return !isRequest;
  });

  return {
    data: historyData,
    filteredData: historyData,
    loading: tabsStore.historyListLoading(),
    subSelected: subdivisionStore.isSubSelected(),
    territorySelected: territoryStore.isTerritorySelected(),
    selectedTerritory: territoryStore.getSelectedTerritory(),
    subdivisions: subdivisionStore.getSelectedSub(),
    subsForTerritory: subdivisionStore.getSubList(),
    sortBy: "type",
    disableHeader: false,
    useDynamicRowHeight: false,
    sortDirection: SortDirection.ASC,
    rowHeight: 23,
    headerHeight: 30,
    overscanRowCount: 10,
  };
}

export const HistoryPage = createReactClass({
  componentDidMount: function () {
    $("#mainSchematic").empty();
    var subDiv = {};
    subDiv.subdivision = getQryValue("sub");
    document.title = "History - " + subDiv.subdivision;
    ServerActions.getRequestListForHistory(subDiv);
    tabsStore.subscribe(this._onChange);
  },

  componentWillUnmount: function () {
    tabsStore.unsubscribe(this._onChange);
  },

  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  _rowClassName({ index }) {
    if (index < 0) {
      return "headerRow";
    } else {
      return index % 2 === 0 ? "oddRow" : "evenRow";
    }
  },

  _noRowsRenderer() {
    return <div className="noRows">No rows found</div>;
  },

  _getRestctionTimeZone(item) {
    var filterRestrictionTimeZone = "";
    if (
      item.restrictionTimeZone != null &&
      item.restrictionTimeZone.length == 6
    ) {
      filterRestrictionTimeZone = item.restrictionTimeZone;
    } else {
      var m = moment(item.issueTime, "YYYY-MM-DD HH:mm:ss");
      if (!m.isValid()) {
        filterRestrictionTimeZone = "N/A";
      } else {
        item.restrictionTimeZone = m.format("HH:mm") + item.restrictionTimeZone;
        filterRestrictionTimeZone = item.restrictionTimeZone;
      }
    }
    return filterRestrictionTimeZone;
  },

  _getIssueTime(item) {
    var filterIssueTime = "";
    if (item.issueTime != null && item.issueTime.indexOf("/") > -1) {
      filterIssueTime = item.issueTime;
    } else {
      var m = moment(item.issueTime, "YYYY-MM-DD HH:mm:ss");
      if (!m.isValid()) {
        filterIssueTime = "N/A";
      } else {
        filterIssueTime = m.format("MM/DD/YY ddd");
      }
    }
    return filterIssueTime;
  },

  _sort({ sortBy, sortDirection }) {
    const comparer = (a, b) => {
      if (sortBy == "syncId") {
        var a = a["syncId"] ? "GR" + a["syncId"] : "";
        var b = b["syncId"] ? "GR" + b["syncId"] : "";
        if (sortDirection === "ASC") {
          return a > b ? 1 : -1;
        } else if (sortDirection === "DESC") {
          return a < b ? 1 : -1;
        }
      } else if (sortBy == "dsInits") {
        var a = a["status"] == "request" ? "" : a["dsInits"];
        var b = b["status"] == "request" ? "" : b["dsInits"];
        if (sortDirection === "ASC") {
          return a > b ? 1 : -1;
        } else if (sortDirection === "DESC") {
          return a < b ? 1 : -1;
        }
      } else if (sortBy == "restrictionTimeZone") {
        var a = this._getRestctionTimeZone(a);
        var b = this._getRestctionTimeZone(b);
        if (sortDirection === "ASC") {
          return a > b ? 1 : -1;
        } else if (sortDirection === "DESC") {
          return a < b ? 1 : -1;
        }
      } else if (sortBy == "issueTime") {
        var a = this._getIssueTime(a);
        var b = this._getIssueTime(b);
        if (sortDirection === "ASC") {
          return a > b ? 1 : -1;
        } else if (sortDirection === "DESC") {
          return a < b ? 1 : -1;
        }
        //			}else if (sortBy == "tracks") {
        //	    			 var a = a['tracks'].length > 1 ? "*Multiple*" : a['tracks'][0]
        //					 var b = b['tracks'].length > 1 ? "*Multiple*" : b['tracks'][0]
        //		       	      if (sortDirection === 'ASC') {
        //		       	        return (a > b) ? 1 : -1;
        //		       	      } else if (sortDirection === 'DESC') {
        //		       	        return (a < b) ? 1 : -1;
        //		       	      }
      } else {
        if (sortDirection === "ASC") {
          return a[sortBy] > b[sortBy] ? 1 : -1;
        } else if (sortDirection === "DESC") {
          return a[sortBy] < b[sortBy] ? 1 : -1;
        }
      }
    };

    const rows =
      sortDirection === "NONE"
        ? this.state.originalRows.slice(0)
        : this.state.filteredData.sort(comparer);

    this.setState({ rows });
    this.setState({ sortBy, sortDirection });
  },

  _filterRecordsOfTheTable(value) {
    var dataSet = this.state.data;
    dataSet = dataSet.filter(function (item) {
      var filterIssueTime = "",
        filterRestrictionTimeZone = "";

      if (
        item.restrictionTimeZone != null &&
        item.restrictionTimeZone.length == 6
      ) {
        filterRestrictionTimeZone = item.restrictionTimeZone;
      } else {
        var m = moment(item.issueTime, "YYYY-MM-DD HH:mm:ss");
        if (!m.isValid()) {
          filterRestrictionTimeZone = "N/A";
        } else {
          item.restrictionTimeZone =
            m.format("HH:mm") + item.restrictionTimeZone;
          filterRestrictionTimeZone = item.restrictionTimeZone;
        }
      }

      if (item.issueTime != null && item.issueTime.indexOf("/") > -1) {
        filterIssueTime = item.issueTime;
      } else {
        var m = moment(item.issueTime, "YYYY-MM-DD HH:mm:ss");
        if (!m.isValid()) {
          filterIssueTime = "N/A";
        } else {
          filterIssueTime = m.format("MM/DD/YY ddd");
        }
      }

      let searchDecVal = value.trim().split(".");
      if (searchDecVal.length === 2) {
        if (/^0*$/.test(searchDecVal[1])) {
          value = searchDecVal[0];
        }
      }

      if (
        (item.subdivision + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        ("Form " + item.type)
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        ((item.controlNumber == 0 ? "--" : item.controlNumber) + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        ((item.syncId ? "GR" + item.syncId : "") + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        (item.status + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        (item.workStartMp + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        ((item.status == "request" ? "" : item.dsInits) + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        //					  ((((item.tracks.length > 1) ? "*Multiple*" : item.tracks[0] ) + "").toString().toUpperCase().indexOf(value.toString().toUpperCase()) !== -1 ) ||
        (filterIssueTime + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        (filterRestrictionTimeZone + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        (item.fromLocation + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        (item.toLocation + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        (item.workEndMp + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1
      ) {
        return true;
      }
    });
    this.setState({ filteredData: dataSet });
  },

  formatValue({ dataKey, rowData }) {
    if (dataKey === "dsInits") {
      return rowData.status === "request" ? "" : rowData.dsInits;
    } else if (dataKey === "subdivision") {
     if (rowData.subdivision === "MULTI") {
       return renderMultiSubHover(rowData.subdivisions);
     } else {
       return rowData.subdivision;
     }
    } else if (dataKey === "restrictionTimeZone") {
      return this._getRestctionTimeZone(rowData);
    } else if (dataKey === "issueTime") {
      return this._getIssueTime(rowData);
    } else if (dataKey === "workEndMp") {
      if (rowData.subdivision === "MULTI" || rowData.subdivision === "ALL") {
        return "";
      } else {
        if (
          rowData.toLocation !== null &&
          rowData.fromLocation !== undefined &&
          rowData.toLocation !== ""
        ) {
          return rowData.toLocation;
        } else {
          return (
            formatMp(rowData.workEndMp) +
            (rowData.workEndMpSuffix ? rowData.workEndMpSuffix : "")
          );
        }
      }
    } else if (dataKey === "workStartMp") {
      if (rowData.subdivision === "MULTI" || rowData.subdivision === "ALL") {
        return "";
      } else {
        if (
          rowData.fromLocation !== null &&
          rowData.fromLocation !== undefined &&
          rowData.fromLocation !== ""
        ) {
          return rowData.fromLocation;
        } else {
          return (
            formatMp(rowData.workStartMp) +
            (rowData.workStartMpSuffix ? rowData.workStartMpSuffix : "")
          );
        }
      }
    } else if (dataKey === "syncId") {
      return rowData.syncId ? "GR" + rowData.syncId : "";
    } else if (dataKey === "controlNumber") {
      return rowData.controlNumber === 0 ? "--" : rowData.controlNumber;
    } else if (dataKey === "type") {
      return "Form " + rowData.type.trim();
    } else if (dataKey === "status") {
      return rowData.status.trim().toUpperCase();
    }
  },

  _onRowClick({ rowData }) {
    ServerActions.viewRequestHistory(rowData.syncId);
  },

  render: function () {
    const { rowHeight, headerHeight, overscanRowCount, sortBy, sortDirection } =
      this.state;

    var content = "Loading....Please wait";

    if (this.state.loading) {
      content = "Loading....Please wait";
    } else {
      var list = this.state.filteredData;
      var content = (
        <div style={{ height: "100%" }}>
          <div id="accordion" className="ui-widget-HistoryTableHeader">
            <span>
              <b>Search: </b>
            </span>
            <input
              type="text"
              onChange={(event) =>
                this._filterRecordsOfTheTable(event.target.value)
              }
            />
          </div>

          <ContentBox className="currentSchematic">
            <div style={{ height: "85vh" }}>
              <AutoSizer>
                {({ height, width }) => (
                  <Table
                    ref="Table"
                    disableHeader={false}
                    headerClassName="historyheaderColumn"
                    width={width}
                    height={height}
                    headerHeight={headerHeight}
                    rowHeight={rowHeight}
                    overscanRowCount={overscanRowCount}
                    rowCount={list.length}
                    rowClassName={this._rowClassName}
                    sort={this._sort}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                    noRowsRenderer={this._noRowsRenderer}
                    onRowDoubleClick={this._onRowClick}
                    rowGetter={({ index }) => list[index]}
                  >
                    <Column
                      width={width * 0.22}
                      label="Subdivision"
                      dataKey="subdivision"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.16}
                      label="Type"
                      dataKey="type"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.16}
                      label="Restrn#"
                      dataKey="controlNumber"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.15}
                      label="Grit Id"
                      dataKey="syncId"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.21}
                      label="Status"
                      dataKey="status"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.18}
                      label="From"
                      dataKey="workStartMp"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.17}
                      label="To"
                      dataKey="workEndMp"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.22}
                      label="Issued Date"
                      dataKey="issueTime"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.22}
                      label="Issued Time"
                      dataKey="restrictionTimeZone"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.17}
                      label="Auth Init"
                      dataKey="dsInits"
                      cellRenderer={this.formatValue}
                    />
                    <Column width={0} dataKey="id" />
                  </Table>
                )}
              </AutoSizer>
            </div>
          </ContentBox>
          <div id="accordion" className="ui-widget-TableFooter">
            {" "}
          </div>
        </div>
      );
    }

    return <div className="positionUnderHeader">{content}</div>;
  },
});

function formatMp(mp) {
  var mpRegexNoDecimal = new RegExp(formValidation.regex.mpRegexNoDecimal);

  if (mpRegexNoDecimal.test(mp)) {
    return mp + ".0";
  }
  return mp;
}

function renderMultiSubHover(subs) {
  if (subs && subs.length > 0) {
    //sorting the MULTI Sub list first to show them in an alphabetic order as seen in mainframe
    subs.sort();
    const popover = (
      <Popover id="popover-subs">
        <table>
          <tbody>
            {subs.map((val, i) => (
              <tr key={i}>
                <td>{val}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Popover>
    );

    return (
      <OverlayTrigger placement="right" overlay={popover}>
        <span>MULTI</span>
      </OverlayTrigger>
    );
  }
  else {
    return (
        <span>MULTI</span>
    );
  }
}
